import type { AccessLevel } from '@atlassian/jira-shared-types';
import ProjectAccessApp, { type Props as ProjectAccessProps } from './app/project-access-app';

export type { AccessLevel, ProjectAccessProps };

export default ProjectAccessApp;
